import { httpClient, httpClientHeader } from '../../services/httpClient';

const API_URL = '/_api/wix-new-releases-service/v1/events';

export const reportEvent = ({
  type,
  metaSiteInstance,
  language,
}: {
  type: string;
  metaSiteInstance: string;
  language?: string;
}): Promise<any> => {
  const headers = {
    Authorization: metaSiteInstance,
    wixLanguage: language,
    ...httpClientHeader,
  };

  return httpClient
    .post(API_URL, { event: { type } }, { headers })
    .catch((e) => {
      throw new Error(`Failed to report event with error: ${e}`);
    });
};
